import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { ENVIRONMENT } from '../environments/environment';
import { ROUTES } from './app.routes';
import { provideEnvironmentConfig } from './core/providers/environment.provider';
import { provideConfirmationService } from './core/services/confirmation.service';
import { AnalyticsService } from './modules/shipping/services/analytics.service';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    AnalyticsService,
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(ROUTES),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideEnvironmentConfig(ENVIRONMENT),
    provideConfirmationService(),
  ],
};
